import { sortAlphabeticallyByName } from '../../../utilities/options.util'
import { PatientMedicalHistoryConstants } from './patientMedicalHistory.constants'
import { IPatientMedicalHistoryAction, IPatientMedicalHistoryState } from './patientMedicalHistory.types'

export const initialPatientMedicalHistoryState: IPatientMedicalHistoryState = {
  medicalHistory: [],
  medicalHistoryPNNV: null,
  noKnownHistory: false,
  isLoading: true,
  medicalHistoryIcdNemsisBasic: [],
  obtainedFrom: [],
  emergencyInfoForm: null,
}

export function patientMedicalHistoryReducer(
  state: IPatientMedicalHistoryState = initialPatientMedicalHistoryState,
  action: IPatientMedicalHistoryAction
): IPatientMedicalHistoryState {
  switch (action.type) {
    case PatientMedicalHistoryConstants.SET_SELECTED_MEDICAL_HISTORY:
      return { ...state, medicalHistory: action.medicalHistory }
    case PatientMedicalHistoryConstants.SET_SELECTED_MEDICAL_HISTORY_PNNV:
      return { ...state, medicalHistoryPNNV: action.medicalHistoryPNNV }
    case PatientMedicalHistoryConstants.SET_SELECTED_MEDICAL_HISTORY_ICD_NEMSIS_BASIC:
      return { ...state, medicalHistoryIcdNemsisBasic: action.medicalHistoryIcdNemsisBasic }
    case PatientMedicalHistoryConstants.SET_NO_KNOWN_HISTORY:
      return { ...state, noKnownHistory: action.noKnownHistory }
    case PatientMedicalHistoryConstants.SET_PATIENT_MEDICAL_HISTORY:
      return { ...state, ...action.patientMedicalHistory }
    case PatientMedicalHistoryConstants.RESET_STATE:
      return { ...initialPatientMedicalHistoryState, medicalHistory: [], medicalHistoryIcdNemsisBasic: [] }
    case PatientMedicalHistoryConstants.SET_IS_LOADING:
      return { ...state, isLoading: action.isLoading }
    case PatientMedicalHistoryConstants.SET_OBTAINED_FROM:
      return { ...state, obtainedFrom: sortAlphabeticallyByName(action.obtainedFrom) }
    case PatientMedicalHistoryConstants.SET_EMERGENCY_INFO_FORM:
      return { ...state, emergencyInfoForm: action.emergencyInfoForm }
    default:
      return state
  }
}
